import React, { useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import { base_url } from "../utils/baseUrl";

const AddAttribute = () => {
  const [attributeName, setAttributeName] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!attributeName.trim()) {
      toast.error("Attribute name is required");
      return;
    }

    try {
      await axios.post(`${base_url}/api/attributes`, { name: attributeName });
      toast.success("Attribute added successfully!");
      setAttributeName(""); // Reset the input field
    } catch (error) {
      console.error("Error adding attribute:", error);
      toast.error("Failed to add attribute.");
    }
  };

  return (
    <div>
      <h3 className="mb-4 title">Add Attribute</h3>
      <form onSubmit={handleSubmit} className="d-flex gap-3 flex-column">
        <input
          type="text"
          className="form-control"
          placeholder="Enter Attribute Name"
          value={attributeName}
          onChange={(e) => setAttributeName(e.target.value)}
        />
        <button type="submit" className="btn btn-success mt-4">
          Add Attribute
        </button>
      </form>
    </div>
  );
};

export default AddAttribute;
